import useFootnote from '../hooks/use_footnote';
import PropTypes from 'prop-types';
import { memo } from 'react';

const Footnote = ({ id, variant, content, isSuper = true, isBold }) => {
  const symbol = useFootnote(id, content, variant);
  const boldWrapper = isBold ? <b>{symbol}</b> : symbol;
  const supWrapper = isSuper ? <sup>{boldWrapper}</sup> : boldWrapper;

  return <span id={`footnote-symbol-${id}`}>{supWrapper}</span>;
};

Footnote.propTypes = {
  id: PropTypes.string.isRequired,
  isSuper: PropTypes.bool,
  isBold: PropTypes.bool,
  variant: PropTypes.string,
  content: PropTypes.any.isRequired,
};

export default memo(Footnote);
